module.exports = __webpack_public_path__ + "img/9788982739019.3912f14d.jpg";